import {Injectable} from '@angular/core';
import {API} from './api.service';
import {ES} from './es.service';
import * as _ from 'lodash';

@Injectable()
export class MessagesServices {
    public messags;

    constructor(private api: API) {
        this.getSystemMessages();
    }

    public getSystemMessages() {
        // return this.api.get('systemmessages/loadmessages');
        // this.messags = this.api.get('systemmessages/loadmessages');
        // this.api.get('systemmessages/loadmessages').subscribe((data) => {
        //     this.messags = data;
        // });
        this.messags = [{
            "id": 1,
            "title": "",
            "message": "Current item has been added to your discoveries.",
            "event": "WG_EVENT_ADDED_TO_DISCOVERIES",
            "notes": "WG_EVENT_ADDED_TO_DISCOVERIES",
            "Updated_at": "2017-12-13 17:41:41",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 2,
            "title": "",
            "message": "Current item cannot be added to your discoveries.",
            "event": "WG_EVENT_CANNOT_ADD_TO_DISCOVERIES",
            "notes": "WG_EVENT_CANNOT_ADD_TO_DISCOVERIES",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 3,
            "title": "",
            "message": "Current item has been removed from your discoveries.",
            "event": "WG_EVENT_REMOVED_FROM_DISCOVERIES",
            "notes": "WG_EVENT_REMOVED_FROM_DISCOVERIES",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 4,
            "title": "",
            "message": "Current song cannot be removed from your discoveries due to network error, please try again.",
            "event": "WG_EVENT_CANNOT_REMOVE_FROM_DISCOVERIES",
            "notes": "WG_EVENT_CANNOT_REMOVE_FROM_DISCOVERIES",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 5,
            "title": "",
            "message": "Added to \"My Music Collection\" section.",
            "event": "WG_EVENT_ADDED_TO_MY-MUSIC-COLLECTION",
            "notes": "WG_EVENT_ADDED_TO_MY-MUSIC-COLLECTION",
            "Updated_at": "2017-12-13 17:42:51",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 6,
            "title": "",
            "message": "Removed from My Music Collection.",
            "event": "WG_EVENT_REMOVED_FROM_MY-MUSIC-COLLECTION",
            "notes": "WG_EVENT_REMOVED_FROM_MY-MUSIC-COLLECTION",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 7,
            "title": "",
            "message": "Cannot Add to My Music Collection.",
            "event": "WG_EVENT_CANNOT_ADD_TO_MY-MUSIC-COLLECTION",
            "notes": "WG_EVENT_CANNOT_ADD_TO_MY-MUSIC-COLLECTION",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 8,
            "title": "",
            "message": "Cannot remove from My Music Collection.",
            "event": "WG_EVENT_CANNOT_REMOVE_FROM_MY-MUSIC-COLLECTION",
            "notes": "WG_EVENT_CANNOT_REMOVE_FROM_MY-MUSIC-COLLECTION",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 9,
            "title": "",
            "message": "Radio has been added to My Radio.",
            "event": "WG_EVENT_ADDED_TO_RADIO",
            "notes": "WG_EVENT_ADDED_TO_RADIO",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 10,
            "title": "",
            "message": "Removed from My Radio.",
            "event": "WG_EVENT_REMOVED_FROM_MY_RADIO",
            "notes": "WG_EVENT_REMOVED_FROM_MY_RADIO",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 11,
            "title": "",
            "message": "You have already purchased this song. Go to My Downloads to download it.",
            "event": "WG_EVENT_ALREADY_ADDED_TO_DOWNLOADS",
            "notes": "WG_EVENT_ALREADY_ADDED_TO_DOWNLOADS",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 12,
            "title": "",
            "message": "Please review your package subscription notes.",
            "event": "WG_EVENT_CANNOT_ADD_TO_DOWNLOADS",
            "notes": "WG_EVENT_CANNOT_ADD_TO_DOWNLOADS",
            "Updated_at": "2017-12-13 17:45:29",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 13,
            "title": "",
            "message": "You have exceeded your download limit, the song has been added to the shopping cart.Please Subscribe new package",
            "event": "WG_EVENT_DOWNLOADS_LIMIT_EXCEEDED",
            "notes": "WG_EVENT_DOWNLOADS_LIMIT_EXCEEDED",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 14,
            "title": "",
            "message": "File has been downloaded to your browser",
            "event": "WG_EVENT_ADDED_TO_DOWNLOADS",
            "notes": "WG_EVENT_ADDED_TO_DOWNLOADS",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 15,
            "title": "",
            "message": "Unable to download this file, please try again.",
            "event": "WG_EVENT_UNABLE_TO_DOWNLOAD_FILE",
            "notes": "WG_EVENT_UNABLE_TO_DOWNLOAD-FILE",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 16,
            "title": "",
            "message": "You already own this song.",
            "event": "WG_EVENT_ALREADY_OWN_THIS_SONG",
            "notes": "WG_EVENT_ALREADY_OWN_THIS_SONG",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 17,
            "title": "",
            "message": "Num Licenses cannot be blank.",
            "event": "WG_EVENT_LICENSES_CANNOT_BE_BLANK",
            "notes": "WG_EVENT_LICENSES_CANNOT_BE_BLANK",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 18,
            "title": "",
            "message": "Your request cannot be entertained by the server. Please try again later.",
            "event": "WG_EVENT_REQUEST_CANNOT_BE_ENTERTAINED",
            "notes": "WG_EVENT_REQUEST_CANNOT_BE_ENTERTAINED",
            "Updated_at": "2017-12-12 12:14:13",
            "created_at": "2017-12-12 12:14:13"
        }, {
            "id": 19,
            "title": "",
            "message": "Item added to cart.",
            "event": "WG_EVENT_ADDED_TO_CART",
            "notes": "WG_EVENT_ADDED_TO_CART",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 20,
            "title": "",
            "message": "Item removed from cart.",
            "event": "WG_EVENT_REMOVED_FROM_THE_CART",
            "notes": "WG_EVENT_REMOVED_FROM_THE_CART",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 21,
            "title": "",
            "message": "Item Already added to cart.",
            "event": "WG_EVENT_ALREADY_IN_THE_CART",
            "notes": "WG_EVENT_ALREADY_IN_THE_CART",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 22,
            "title": "",
            "message": "Your request cannot be entertained by the server. Please try again later.",
            "event": "WG_EVENT_CANNOT_ENTERTAINED_BY_SERVER",
            "notes": "WG_EVENT_CANNOT_ENTERTAINED_BY_SERVER",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 23,
            "title": "",
            "message": "There was an error completing your request. Please try again later.",
            "event": "WG_EVENT_ERROR_IN_COMPLETING_REQUEST",
            "notes": "WG_EVENT_ERROR_IN_COMPLETING_REQUEST",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 24,
            "title": "",
            "message": "Your Transaction has been processed successfully.",
            "event": "WG_EVENT_TRANSACTION_PROCESSED_SUCCESSFULLY",
            "notes": "WG_EVENT_TRANSACTION_PROCESSED_SUCCESSFULLY",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 25,
            "title": "",
            "message": "Your message has been sent to WeGet Support.",
            "event": "WG_EVENT_MESSAGE_SENT_SUCCESSFULLY",
            "notes": "WG_EVENT_MESSAGE_SENT_SUCCESSFULLY",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 26,
            "title": "",
            "message": "Your screen name was updated successfully.",
            "event": "WG_EVENT_SCREEN_NAME_UPDATED_SUCCESSFULLY",
            "notes": "WG_EVENT_SCREEN_NAME_UPDATED_SUCCESSFULLY",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 27,
            "title": "",
            "message": "Image Uploaded Successfully.",
            "event": "WG_EVENT_IMAGE_UPLOADED_SUCCESSFULLY",
            "notes": "WG_EVENT_IMAGE_UPLOADED_SUCCESSFULLY",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 28,
            "title": "",
            "message": "Great! You started following.",
            "event": "WG_EVENT_STARTED_FOLLOWING_THIS_USER",
            "notes": "WG_EVENT_STARTED_FOLLOWING_THIS_USER",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 29,
            "title": "",
            "message": "You are not following this user now!",
            "event": "WG_EVENT_NOT_FOLLOWING_THIS_USER",
            "notes": "WG_EVENT_NOT_FOLLOWING_THIS_USER",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 30,
            "title": "",
            "message": "There is an error in processing",
            "event": "WG_EVENT_COULDNOT_NOT_FOLLOW",
            "notes": "WG_EVENT_COULDNOT_NOT_FOLLOW",
            "Updated_at": "2017-12-14 18:02:44",
            "created_at": "2017-12-14 18:02:44"
        }, {
            "id": 32,
            "title": "",
            "message": "Playlist has been created successfully.",
            "event": "WG_EVENT_PLAYLIST_CREATED_SUCCESSFULLY",
            "notes": "WG_EVENT_PLAYLIST_CREATED_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:28",
            "created_at": "2017-12-15 18:08:28"
        }, {
            "id": 33,
            "title": "",
            "message": "Playlist cannot be created.",
            "event": "WG_EVENT_PLAYLIST_CANNOT_BE_CREATED",
            "notes": "WG_EVENT_PLAYLIST_CANNOT_BE_CREATED",
            "Updated_at": "2017-12-15 18:08:28",
            "created_at": "2017-12-15 18:08:28"
        }, {
            "id": 34,
            "title": "",
            "message": "Playlist Saved.",
            "event": "WG_EVENT_PLAYLIST_UPDATED_SUCCESSFULLY",
            "notes": "WG_EVENT_PLAYLIST_UPDATED_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:28",
            "created_at": "2017-12-15 18:08:28"
        }, {
            "id": 35,
            "title": "",
            "message": "Playlist has been deleted successfully.",
            "event": "WG_EVENT_PLAYLIST_DELETED_SUCCESSFULLY",
            "notes": "WG_EVENT_PLAYLIST_DELETED_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:28",
            "created_at": "2017-12-15 18:08:28"
        }, {
            "id": 36,
            "title": "",
            "message": "Playlist cannot be deleted successfully.",
            "event": "WG_EVENT_PLAYLIST_CANNOT_BE_DELETED",
            "notes": "WG_EVENT_PLAYLIST_CANNOT_BE_DELETED",
            "Updated_at": "2017-12-15 18:08:28",
            "created_at": "2017-12-15 18:08:28"
        }, {
            "id": 37,
            "title": "",
            "message": "Are you sure you want to delete this playlist?",
            "event": "WG_EVENT_ARE_YOU_SURE_TO_DELETE_THIS_PLAYLIST",
            "notes": "WG_EVENT_ARE_YOU_SURE_TO_DELETE_THIS_PLAYLIST",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 38,
            "title": "",
            "message": "Song has been deleted from your playlist.",
            "event": "WG_EVENT_SONG_DELETED_FROM_PLAYLIST",
            "notes": "WG_EVENT_SONG_DELETED_FROM_PLAYLIST",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 39,
            "title": "",
            "message": "Are you sure you want to delete this song from playlist?",
            "event": "WG_EVENT_ARE_YOU_SURE_TO_DELETE_THIS_SONG_FROM_PLAYLIST",
            "notes": "WG_EVENT_ARE_YOU_SURE_TO_DELETE_THIS_SONG_FROM_PLAYLIST",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 40,
            "title": "",
            "message": "Password changed successfully.",
            "event": "WG_EVENT_PASSWORD_CHANGE_SUCCESSFULLY",
            "notes": "WG_EVENT_PASSWORD_CHANGE_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 41,
            "title": "",
            "message": "An email is sent to your email with your screenname.",
            "event": "WG_EVENT_EMAIL_WITH_SCREEN_NAME_SENT_SUCCESSFULLY",
            "notes": "WG_EVENT_EMAIL_WITH_SCREEN_NAME_SENT_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 42,
            "title": "",
            "message": "",
            "event": "WG_EVENT_REQUEST_NOT_SUCCESSFULL",
            "notes": "WG_EVENT_REQUEST_NOT_SUCCESSFULL",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 43,
            "title": "",
            "message": "Account verification email has been sent successfully",
            "event": "WG_EVENT_VERIFICATION_EMAIL_SENT_SUCCESSFULLY",
            "notes": "WG_EVENT_VERIFICATION_EMAIL_SENT_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 44,
            "title": "",
            "message": "Email Not Found",
            "event": "WG_EVENT_EMAIL_NOT_FOUND",
            "notes": "WG_EVENT_EMAIL_NOT_FOUND",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 45,
            "title": "",
            "message": "Are you sure you want to cancel this subscription?",
            "event": "WG_EVENT_ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_SUBSCRIPTION",
            "notes": "WG_EVENT_ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_SUBSCRIPTION",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 46,
            "title": "",
            "message": "Subscription has been cancelled successfully.",
            "event": "WG_EVENT_SUBSCRIPTION_CANCELLED_SUCCESSFULLY",
            "notes": "WG_EVENT_SUBSCRIPTION_CANCELLED_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 47,
            "title": "",
            "message": "Subscription cannot be cancelled.",
            "event": "WG_EVENT_SUBSCRIPTION_CANNOT_BE_CANCELLED",
            "notes": "WG_EVENT_SUBSCRIPTION_CANNOT_BE_CANCELLED",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 48,
            "title": "",
            "message": "Visibility in search results updated.",
            "event": "WG_EVENT_VISIBILITY_IN_SEARCH_RESULTS_UPDATED",
            "notes": "WG_EVENT_VISIBILITY_IN_SEARCH_RESULTS_UPDATED",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 49,
            "title": "",
            "message": "User Bio has been updated.",
            "event": "WG_EVENT_USER_BIO_UPDATED",
            "notes": "WG_EVENT_USER_BIO_UPDATED",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 50,
            "title": "",
            "message": "Your password has been changed successfully.",
            "event": "WG_EVENT_YOUR_PASSWORD_CHANGED_SUCCESSFULLY",
            "notes": "WG_EVENT_YOUR_PASSWORD_CHANGED_SUCCESSFULLY",
            "Updated_at": "2017-12-15 18:08:29",
            "created_at": "2017-12-15 18:08:29"
        }, {
            "id": 51,
            "title": "",
            "message": "You are not subscribed to a package that includes unlimited listening. Please go to My Packages and choose a listening plan, or continue to enjoy one-minute demos of the songs you choose.",
            "event": "WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER",
            "notes": "WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER",
            "Updated_at": "2018-01-10 16:57:15",
            "created_at": "2017-12-19 06:36:18"
        }, {
            "id": 52,
            "title": "",
            "message": "Your current song listens quota is exceeded.Please login or signup to enjoy unlimited song listening, or you can listen to as many minute-long demos as you like.",
            "event": "WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_VISITORS",
            "notes": "WG_EVENT_SONG_LISTEN_QUOTA_EXCEEDED_FOR_VISITORS",
            "Updated_at": "2018-01-08 13:21:07",
            "created_at": "2017-12-19 06:36:18"
        }, {
            "id": 53,
            "title": "",
            "message": "You are already logged in. Please log out before creating a new account.",
            "event": "WG_EVENT_ALREADY_LOGGED_IN",
            "notes": "WG_EVENT_ALREADY_LOGGED_IN",
            "Updated_at": "2018-01-02 12:23:41",
            "created_at": "2018-01-02 12:23:41"
        }, {
            "id": 54,
            "title": "",
            "message": "Either you are not subscribed to a package that includes downloads or you have exceeded your monthly download limit.\nThe song has been added to your shopping cart for individual purchase",
            "event": "WG_EVENT_SONG_DOWNLOAD_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER",
            "notes": "WG_EVENT_SONG_DOWNLOAD_QUOTA_EXCEEDED_FOR_LOGGED_IN_USER",
            "Updated_at": "2018-01-03 14:30:26",
            "created_at": "2018-01-03 14:30:26"
        }, {
            "id": 55,
            "title": "",
            "message": "Only logged in visitors are able to download songs",
            "event": "WG_EVENT_SONG_DOWNLOAD_QUOTA_EXCEEDED_FOR_VISITORS",
            "notes": "WG_EVENT_SONG_DOWNLOAD_QUOTA_EXCEEDED_FOR_VISITORS",
            "Updated_at": "2018-01-03 14:30:26",
            "created_at": "2018-01-03 14:30:26"
        }
    ]
        ;
    }

}


// WEBPACK FOOTER //
// ./src/app/api/services/systemmessages.service.ts